import React, { useState } from 'react'
import Carousel, { Modal, ModalGateway } from 'react-images'
import {
  CFImage,
  CFLink,
  CFSelect,
  CFView,
  DefaultScreen,
  LocationSelect,
  MobileScreen,
} from 'components'
import { headerBg, logo, logoTitle, viewMenu } from 'images'
import { dispatch } from 'store'

const orderingUrl =
  process.env.REACT_APP_ENVIRONMENT === 'dev'
    ? 'https://demo.codefusion.tech/restaurants/ebisu/locations/ebisuLocation1'
    : 'https://order.codefusion.tech/restaurants/NmljFgO1p1b0DnWwM4Lw/locations/Ab8324iqgy4BQgWK2Ufi'

const images = []

export default () => {
  const [showModal, setShowModal] = useState(false)

  return (
    <>
      <MobileScreen>
        <CFView
          column
          center
          w="100%"
          h="70px"
          bg="rgba(0,0,0,0.85)"
          boxShadow="0 2px 2px rgba(0,0,0,.8)"
        >
          <CFView row center>
            <CFImage h="50px" src={logo} alt="Hanayuki Sushi Logo" />
            {/* <CFImage
              h="30px"
              ml="20px"
              src={logoTitle}
              alt="Hanayuki Sushi Logo Title"
            /> */}
          </CFView>
        </CFView>
      </MobileScreen>
      <DefaultScreen>
        <CFView
          column
          bg="rgba(0,0,0,0.85)"
          boxShadow="0 2px 2px rgba(0,0,0,.8)"
          center
          w="100%"
          zIndex={98}
        >
          <CFView row justifyBetween alignCenter w="100%" maxWidth="1400px">
            <CFView row center mv="5px">
              <CFImage
                h="60px"
                ml="15px"
                src={logo}
                alt="Hanayuki Sushi Logo"
                zIndex={98}
              />
              {/* <CFImage
                h="30px"
                ml="15px"
                src={logoTitle}
                alt="Hanayuki Sushi Logo Title"
              /> */}
            </CFView>
            {/* <CFView hover mt="10px">
              <CFLink href={orderingUrl}>
                <CFImage
                  h="70px"
                  src={viewMenu}
                  alt="Hanayuki Sushi View Menu Button"
                />
              </CFLink>
            </CFView> */}
          </CFView>
        </CFView>
      </DefaultScreen>
      <ModalGateway>
        {showModal ? (
          <Modal onClose={() => setShowModal(false)}>
            <Carousel views={images} />
          </Modal>
        ) : null}
      </ModalGateway>
    </>
  )
}
